// import { const_var, params } from "../redux/reducers/reducer";
import * as utils from "../../redux/reducers/utils";
import { getBuildingPricingData, getGaugeRoofCost } from "./buildingPricing.helper";
import { CheckDoorWindowsInstallationFees } from "../../action";
import { const_var, params } from "../../redux/reducers/common/stateObjects";
import { setPricingData } from "../../action/building_pricing/buildingPricing.action";
import { applicableWainscot } from "../building/building_color/wainscotColor.helper";
import { commonFunctionForInsulationCalculations, commonFunctionForRoofandFullBuildingInsulationPrice } from "../insulation_pricing/insulationPricing.helper";
import { deleteUncheckWallsfromInsulationWalls } from "../lean_building_pricing/lean_building_wall/leanBuildingWall.helper";
import { setZeroPriceOverhang } from "../extra_options_pricing/overhangPricing";

export const handleRoofBaseCalculation = ({ data, params, const_var, post_data, t_c }) => {
	let CalCulateRoofBasePrice = 0;

	const hasBase = data.base.length > 0;
	const isPriceChanged = const_var.UpdatedPriceData.roof_style_price_changed != true;

	let roofStylePrice = 0;

	if (hasBase) {
		const cost = getGaugeRoofCost(data.base, params.p_r_s, const_var.g_v);
		roofStylePrice = isPriceChanged ? const_var.UpdatedPriceData.roof_style_price : cost;
		const editData = const_var.editAPIDataByResponse?.data?.request_data?.building;

		if (const_var.crmSetting.is_Edit == true && editData?.gauge_price !== undefined && editData.gauge_price != 0) {
			roofStylePrice = cost;
		}
	} else {
		roofStylePrice = isPriceChanged ? const_var.UpdatedPriceData.roof_style_price : 0;
	}

	post_data.building.roof_style_price = roofStylePrice;

	t_c = parseFloat(t_c) + parseFloat(roofStylePrice);

	CalCulateRoofBasePrice = roofStylePrice;
	post_data.building.gauge_price = 0;

	return {
		t_c,
		CalCulateRoofBasePrice,
		post_data
	};
};
export function handleSidePanelEndData({ data, params, const_var, isLean }) {
	let heightFullData;

	const hasValue = (val) => val != undefined && val.length > 0;
	if (params.p_u_c == true) {
		console.log("params.p_u_c ", params.p_u_c);
		data.side = data.side;
		data.panel = data.panel;
		data.end = data.end;

		heightFullData = data.full_length_side != undefined ? data.full_length_side : data.side;
	} else {
		data.side = data.full_length_side != undefined ? data.full_length_side : data.side;

		data.panel = data.full_length_panel != undefined && !const_var.checkPanelForLean.left && !const_var.checkPanelForLean.right ? data.full_length_panel : data.panel;

		data.end = data.central_end != undefined && data.central_end.length > 0 ? data.central_end : data.end;

		heightFullData = data.full_length_side != undefined ? data.full_length_side : data.side;
		const applyLeanSide = (leanData) => {
			if (hasValue(leanData?.central_side)) {
				data.side = leanData.central_side;
				heightFullData = leanData.central_side_full_length != undefined ? leanData.central_side_full_length : data.side;
			}
		};

		const applyLeanEnd = (leanData) => {
			if (hasValue(leanData?.central_end)) {
				data.end = leanData.central_end;
			}
		};

		if (isLean != undefined && params.add_left_lean == true) {
			applyLeanSide(const_var.leanGetDataLeft);
			applyLeanEnd(const_var.leanGetDataLeft);
		}

		if (isLean != undefined && params.add_front_lean == true) {
			applyLeanSide(const_var.leanGetDataFront);
			applyLeanEnd(const_var.leanGetDataFront);
		}

		if (isLean != undefined && params.add_right_lean == true) {
			applyLeanSide(const_var.leanGetDataRight);
			applyLeanEnd(const_var.leanGetDataRight);
		}

		if (isLean != undefined && params.add_back_lean == true) {
			applyLeanSide(const_var.leanGetDataBack);
			applyLeanEnd(const_var.leanGetDataBack);
		}
	}

	return {
		data,
		heightFullData
	};
}
export const handleConnectionFeesCalculation = ({ data, params, const_var, a, connection_feesCost = 0, connection_feesEnd = 0 }) => {
	const hasConnectionFees = data.connection_fees != undefined && data.connection_fees.length > 0;

	const hasLean = (leanData) => leanData != "" && leanData != undefined && leanData.connection_fees?.length > 0;

	if (hasConnectionFees) {
		if (params.add_right_lean == true && hasLean(const_var.leanGetDataRight)) {
			const rightData = const_var.leanGetDataRight.connection_fees[0];

			connection_feesCost =
				const_var.UpdatedPriceData.connection_fee_side_changed != true
					? const_var.UpdatedPriceData.connection_fee_side
					: (const_var.isLTBuilding && params.leanStyle.right == "gable" && rightData.added_building_cost != undefined ? rightData.added_building_cost : rightData.cost) + connection_feesCost;

			a.connection_fee_side = connection_feesCost;
		}

		// LEFT
		if (params.add_left_lean == true && hasLean(const_var.leanGetDataLeft)) {
			const leftData = const_var.leanGetDataLeft.connection_fees[0];

			connection_feesCost =
				const_var.UpdatedPriceData.connection_fee_side_changed != true
					? const_var.UpdatedPriceData.connection_fee_side
					: (const_var.isLTBuilding && params.leanStyle.left == "gable" && leftData.added_building_cost != undefined ? leftData.added_building_cost : leftData.cost) + connection_feesCost;

			a.connection_fee_side = connection_feesCost;
		}

		// FRONT
		if (params.add_front_lean == true && hasLean(const_var.leanGetDataFront)) {
			const frontData = const_var.leanGetDataFront.connection_fees[0];

			connection_feesCost = const_var.UpdatedPriceData.connection_fee_side_changed != true ? const_var.UpdatedPriceData.connection_fee_side : frontData.end_cost + connection_feesCost;

			a.connection_fee_side = connection_feesCost;
		}

		// BACK
		if (params.add_back_lean == true && hasLean(const_var.leanGetDataBack)) {
			const backData = const_var.leanGetDataBack.connection_fees[0];

			connection_feesCost = const_var.UpdatedPriceData.connection_fee_side_changed != true ? const_var.UpdatedPriceData.connection_fee_side : backData.end_cost + connection_feesCost;

			a.connection_fee_side = connection_feesCost;
		}
	} else {
		a.connection_fee_side = 0;
	}

	if (hasConnectionFees) {
		// RIGHT
		if (params.add_right_lean == true && hasLean(const_var.leanGetDataRight)) {
			const rightData = const_var.leanGetDataRight.connection_fees[0];

			connection_feesEnd = const_var.UpdatedPriceData.connection_fee_end_changed != true ? const_var.UpdatedPriceData.connection_fee_end : rightData.end_cost + connection_feesEnd;

			a.connection_fee_end = connection_feesEnd;
		}

		// LEFT
		if (params.add_left_lean == true && hasLean(const_var.leanGetDataLeft)) {
			const leftData = const_var.leanGetDataLeft.connection_fees[0];

			connection_feesEnd = const_var.UpdatedPriceData.connection_fee_end_changed != true ? const_var.UpdatedPriceData.connection_fee_end : leftData.end_cost + connection_feesEnd;

			a.connection_fee_end = connection_feesEnd;
		}

		// FRONT
		if (params.add_front_lean == true && hasLean(const_var.leanGetDataFront)) {
			const frontData = const_var.leanGetDataFront.connection_fees[0];

			connection_feesEnd =
				const_var.UpdatedPriceData.connection_fee_end_changed != true
					? const_var.UpdatedPriceData.connection_fee_end
					: (const_var.isLTBuilding && params.leanStyle.front == "gable" && frontData.added_building_cost != undefined
							? frontData.added_building_cost
							: frontData.end_leanto_cost
								? frontData.end_leanto_cost
								: frontData.cost) + connection_feesEnd;

			a.connection_fee_end = connection_feesEnd;
		}

		// BACK
		if (params.add_back_lean == true && hasLean(const_var.leanGetDataBack)) {
			const backData = const_var.leanGetDataBack.connection_fees[0];

			connection_feesEnd =
				const_var.UpdatedPriceData.connection_fee_end_changed != true
					? const_var.UpdatedPriceData.connection_fee_end
					: (const_var.isLTBuilding && params.leanStyle.back == "gable" && backData.added_building_cost != undefined
							? backData.added_building_cost
							: backData.end_leanto_cost
								? backData.end_leanto_cost
								: backData.cost) + connection_feesEnd;

			a.connection_fee_end = connection_feesEnd;
		}

		// FINAL BASE END COST (IMPORTANT — kept same order)
		connection_feesEnd = const_var.UpdatedPriceData.connection_fee_end_changed != true ? const_var.UpdatedPriceData.connection_fee_end : data.connection_fees[0].end_cost + connection_feesEnd;

		a.connection_fee_end = connection_feesEnd;
	} else {
		a.connection_fee_end = 0;
	}

	return {
		a,
		connection_feesCost,
		connection_feesEnd
	};
};
export const calculateWalls = ({
	params,
	data,
	const_var,
	UpdatePriceRecord,
	post_data,
	t_c,
	CalCulateRoofEndClosePrice,
	LeftWallSidePrice,
	endCostV3_front,
	endCostV3_back,
	utlis,
	vertiP2,
	vertiP,
	convertToTwoDecimalNumber,
	CalCulateRoofEndGablePrice
}) => {
	if (params.p_l_w == "Close") {
		post_data["building"].left_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.left_wall_price_changed != true
				? const_var.UpdatedPriceData.left_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(LeftWallSidePrice[0].vertical_side_cost + LeftWallSidePrice[0].side_close_cost)
					: utlis.convertToTwoDecimalNumber(LeftWallSidePrice[0].side_close_cost);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].left_wall_price);

		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].left_wall_price);
	}
	if (params.p_l_w == "Half_Close") {
		post_data["building"].left_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.left_wall_price_changed != true
				? const_var.UpdatedPriceData.left_wall_price
				: params.p_v_w == true
					? (LeftWallSidePrice[0].half_vertical_side_cost + LeftWallSidePrice[0].half_side_close_cost).toFixed(2)
					: LeftWallSidePrice[0].half_side_close_cost.toFixed(2);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].left_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].left_wall_price);
	}
	if (params.p_l_w == "One_Fourth_Close") {
		post_data["building"].left_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.left_wall_price_changed != true
				? const_var.UpdatedPriceData.left_wall_price
				: params.p_v_w == true
					? (LeftWallSidePrice[0].one_fourth_vertical_side_cost + LeftWallSidePrice[0].one_fourth_side_close_cost).toFixed(2)
					: LeftWallSidePrice[0].one_fourth_side_close_cost.toFixed(2);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].left_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].left_wall_price);
	}
	if (params.p_l_w == "Three_Fourth_Close") {
		post_data["building"].left_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.left_wall_price_changed != true
				? const_var.UpdatedPriceData.left_wall_price
				: params.p_v_w == true
					? (LeftWallSidePrice[0].three_fourth_vertical_side_cost + LeftWallSidePrice[0].three_fourth_side_close_cost).toFixed(2)
					: LeftWallSidePrice[0].three_fourth_side_close_cost.toFixed(2);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].left_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].left_wall_price);
	}
	if (params.p_l_w !== "Close" && params.p_l_w !== "Open" && params.p_l_w !== "Half_Close" && params.p_l_w !== "One_Fourth_Close" && params.p_l_w !== "Three_Fourth_Close") {
		post_data["building"].left_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.left_wall_price_changed != true
				? const_var.UpdatedPriceData.left_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(
							params.add_left_lean == true && const_var.checkPanelForLean.left == true && data.panel[0].vertical_roof_panel_cost != undefined && data.panel[0].vertical_roof_panel_cost != 0
								? data.panel[0].vertical_roof_panel_cost * params.p_l_w
								: data.panel[0].vertical_panel_cost * params.p_l_w
						)
					: utlis.convertToTwoDecimalNumber(
							params.add_left_lean == true && const_var.checkPanelForLean.left == true && data.panel[0].horizontal_roof_panel_cost != undefined && data.panel[0].horizontal_roof_panel_cost != 0
								? data.panel[0].horizontal_roof_panel_cost * params.p_l_w
								: data.panel[0].cost * params.p_l_w
						);

		post_data["building"].left_wall_price =
			params.p_c_p_l == true
				? UpdatePriceRecord == true && const_var.UpdatedPriceData.left_wall_price_changed != true
					? utlis.convertToTwoDecimalNumber(const_var.UpdatedPriceData.left_wall_price)
					: utlis.convertToTwoDecimalNumber(parseFloat(data.panel[0].cut_panel_cost) + parseFloat(post_data["building"].left_wall_price))
				: utlis.convertToTwoDecimalNumber(post_data["building"].left_wall_price);

		t_c = parseFloat(t_c) + parseFloat(post_data["building"].left_wall_price);
	}
	if (params.p_r_w == "Close") {
		post_data["building"].right_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.right_wall_price_changed != true
				? const_var.UpdatedPriceData.right_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(data.side[0].vertical_side_cost + data.side[0].side_close_cost)
					: utlis.convertToTwoDecimalNumber(data.side[0].side_close_cost);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].right_wall_price);

		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].right_wall_price);
	}
	if (params.p_r_w == "Half_Close") {
		post_data["building"].right_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.right_wall_price_changed != true
				? const_var.UpdatedPriceData.right_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(data.side[0].half_vertical_side_cost + data.side[0].half_side_close_cost)
					: utlis.convertToTwoDecimalNumber(data.side[0].half_side_close_cost);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].right_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].right_wall_price);
	}
	if (params.p_r_w == "One_Fourth_Close") {
		post_data["building"].right_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.right_wall_price_changed != true
				? const_var.UpdatedPriceData.right_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(data.side[0].one_fourth_vertical_side_cost + data.side[0].one_fourth_side_close_cost)
					: utlis.convertToTwoDecimalNumber(data.side[0].one_fourth_side_close_cost);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].right_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].right_wall_price);
	}
	if (params.p_r_w == "Three_Fourth_Close") {
		post_data["building"].right_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.right_wall_price_changed != true
				? const_var.UpdatedPriceData.right_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(data.side[0].three_fourth_vertical_side_cost + data.side[0].three_fourth_side_close_cost)
					: utlis.convertToTwoDecimalNumber(data.side[0].three_fourth_side_close_cost);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].right_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].right_wall_price);
	}
	if (params.p_r_w !== "Close" && params.p_r_w !== "Open" && params.p_r_w !== "Half_Close" && params.p_r_w !== "One_Fourth_Close" && params.p_r_w !== "Three_Fourth_Close") {
		post_data["building"].right_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.right_wall_price_changed != true
				? const_var.UpdatedPriceData.right_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(
							params.add_right_lean == true && const_var.checkPanelForLean.right == true && data.panel[0].vertical_roof_panel_cost != undefined && data.panel[0].vertical_roof_panel_cost != 0
								? data.panel[0].vertical_roof_panel_cost * params.p_r_w
								: data.panel[0].vertical_panel_cost * params.p_r_w
						)
					: params.add_right_lean == true && const_var.checkPanelForLean.right == true && data.panel[0].horizontal_roof_panel_cost != undefined && data.panel[0].horizontal_roof_panel_cost != 0
						? data.panel[0].horizontal_roof_panel_cost * params.p_r_w
						: data.panel[0].cost * params.p_r_w;

		post_data["building"].right_wall_price =
			params.p_c_p_r == true
				? UpdatePriceRecord == true && const_var.UpdatedPriceData.right_wall_price_changed != true
					? utlis.convertToTwoDecimalNumber(const_var.UpdatedPriceData.right_wall_price)
					: utlis.convertToTwoDecimalNumber(parseFloat(data.panel[0].cut_panel_cost) + parseFloat(post_data["building"].right_wall_price))
				: utlis.convertToTwoDecimalNumber(post_data["building"].right_wall_price);

		t_c = parseFloat(t_c) + parseFloat(post_data["building"].right_wall_price);
	}
	if (params.p_f_w == "Close") {
		post_data["building"].front_wall_price = params.cB_addStorage_check_front
			? 0
			: UpdatePriceRecord == true && const_var.UpdatedPriceData.front_wall_price_changed != true
				? const_var.UpdatedPriceData.front_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(endCostV3_front?.vertical_ends_cost + endCostV3_front?.end_close_cost)
					: utlis.convertToTwoDecimalNumber(endCostV3_front?.end_close_cost);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].front_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].front_wall_price);
	}

	if (params.p_f_w == "Half End" || params.p_f_w == "Half Dutch End") {
		let dutchPrice = 0;
		if (data.garage_door_frameout != undefined && params.p_f_w == "Half Dutch End") {
			dutchPrice = data.garage_door_frameout[0].dutch_cost;
		}
		post_data["building"].front_wall_price = params.cB_addStorage_check_front
			? 0
			: UpdatePriceRecord == true && const_var.UpdatedPriceData.front_wall_price_changed != true
				? const_var.UpdatedPriceData.front_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(endCostV3_front.vertical_ends_cost / 2 + endCostV3_front.end_close_cost / 2 + dutchPrice)
					: utlis.convertToTwoDecimalNumber(endCostV3_front.end_close_cost / 2 + dutchPrice);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].front_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].front_wall_price);
	}
	if (params.p_f_w == "Half_Close") {
		post_data["building"].front_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.front_wall_price_changed != true
				? const_var.UpdatedPriceData.front_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(endCostV3_front.half_vertical_ends_cost + endCostV3_front.half_end_close_cost)
					: utlis.convertToTwoDecimalNumber(endCostV3_front.half_end_close_cost);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].front_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].front_wall_price);
	}
	if (params.p_f_w == "One_Fourth_Close") {
		post_data["building"].front_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.front_wall_price_changed != true
				? const_var.UpdatedPriceData.front_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(endCostV3_front.one_fourth_vertical_ends_cost + endCostV3_front.one_fourth_end_close_cost)
					: utlis.convertToTwoDecimalNumber(endCostV3_front.one_fourth_end_close_cost);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].front_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].front_wall_price);
	}
	if (params.p_f_w == "Three_Fourth_Close") {
		post_data["building"].front_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.front_wall_price_changed != true
				? const_var.UpdatedPriceData.front_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(endCostV3_front.three_fourth_vertical_ends_cost + endCostV3_front.three_fourth_end_close_cost)
					: utlis.convertToTwoDecimalNumber(endCostV3_front.three_fourth_end_close_cost);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].front_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].front_wall_price);
	}
	if (
		params.p_f_w !== "Half End" &&
		params.p_f_w !== "Half Dutch End" &&
		params.p_f_w !== "Close" &&
		params.p_f_w !== "Open" &&
		params.p_f_w !== "Half_Close" &&
		params.p_f_w !== "One_Fourth_Close" &&
		params.p_f_w !== "Three_Fourth_Close"
	) {
		if (params.p_f_w == "Gable") {
			if (params.p_v_w == true) {
				if (const_var.c_f_a_sCer[params.p_e_i] == 1) {
					vertiP =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_wall_price_changed != true
							? const_var.UpdatedPriceData.front_wall_price
							: vertiP + data.gable_end[0].vertical_certified + data.gable_end[0].certified;
				} else {
					vertiP =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.front_wall_price_changed != true
							? const_var.UpdatedPriceData.front_wall_price
							: vertiP + data.gable_end[0].vertical + data.gable_end[0].uncertified;
				}
			} else {
				if (const_var.c_f_a_sCer[params.p_e_i] == 1) {
					vertiP = UpdatePriceRecord == true && const_var.UpdatedPriceData.front_wall_price_changed != true ? const_var.UpdatedPriceData.front_wall_price : vertiP + data.gable_end[0].certified;
				} else {
					vertiP = UpdatePriceRecord == true && const_var.UpdatedPriceData.front_wall_price_changed != true ? const_var.UpdatedPriceData.front_wall_price : vertiP + data.gable_end[0].uncertified;
				}
			}
		} else {
			if (params.p_v_w == true) {
				vertiP =
					UpdatePriceRecord == true && const_var.UpdatedPriceData.front_wall_price_changed != true
						? const_var.UpdatedPriceData.front_wall_price
						: vertiP + data.gable_end[0].vertical_extended + data.gable_end[0].extended;
			} else {
				vertiP = UpdatePriceRecord == true && const_var.UpdatedPriceData.front_wall_price_changed != true ? const_var.UpdatedPriceData.front_wall_price : vertiP + data.gable_end[0].extended;
			}
		}
		post_data["building"].front_wall_price = utlis.convertToTwoDecimalNumber(vertiP);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].front_wall_price);

		CalCulateRoofEndGablePrice = post_data["building"].front_wall_price;
	}
	if (params.p_b_w == "Close") {
		post_data["building"].back_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.back_wall_price_changed != true
				? const_var.UpdatedPriceData.back_wall_price
				: params.p_v_w == true
					? convertToTwoDecimalNumber(endCostV3_back.vertical_ends_cost + endCostV3_back.end_close_cost)
					: utlis.convertToTwoDecimalNumber(endCostV3_back.end_close_cost);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].back_wall_price);

		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].back_wall_price);
	}
	if (params.p_b_w == "Half End" || params.p_b_w == "Half Dutch End") {
		let dutchPrice = 0;
		if (data.garage_door_frameout != undefined && params.p_b_w == "Half Dutch End") {
			dutchPrice = data.garage_door_frameout[0].dutch_cost;
		}
		post_data["building"].back_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.back_wall_price_changed != true
				? const_var.UpdatedPriceData.back_wall_price
				: params.p_v_w == true
					? convertToTwoDecimalNumber(endCostV3_back.vertical_ends_cost / 2 + endCostV3_back.end_close_cost / 2 + dutchPrice)
					: convertToTwoDecimalNumber(endCostV3_back.end_close_cost / 2 + dutchPrice);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].back_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].back_wall_price);
	}
	if (params.p_b_w == "Half_Close") {
		post_data["building"].back_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.back_wall_price_changed != true
				? const_var.UpdatedPriceData.back_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(endCostV3_back.half_vertical_ends_cost + endCostV3_back.half_end_close_cost)
					: utlis.convertToTwoDecimalNumber(endCostV3_back.half_end_close_cost);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].back_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].back_wall_price);
	}
	if (params.p_b_w == "One_Fourth_Close") {
		post_data["building"].back_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.back_wall_price_changed != true
				? const_var.UpdatedPriceData.back_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(endCostV3_back.one_fourth_vertical_ends_cost + endCostV3_back.one_fourth_end_close_cost)
					: utlis.convertToTwoDecimalNumber(endCostV3_back.one_fourth_end_close_cost);

		t_c = parseFloat(t_c) + parseFloat(post_data["building"].back_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].back_wall_price);
	}
	if (params.p_b_w == "Three_Fourth_Close") {
		post_data["building"].back_wall_price =
			UpdatePriceRecord == true && const_var.UpdatedPriceData.back_wall_price_changed != true
				? const_var.UpdatedPriceData.back_wall_price
				: params.p_v_w == true
					? utlis.convertToTwoDecimalNumber(endCostV3_back.three_fourth_vertical_ends_cost + endCostV3_back.three_fourth_end_close_cost)
					: utlis.convertToTwoDecimalNumber(endCostV3_back.three_fourth_end_close_cost);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].back_wall_price);
		CalCulateRoofEndClosePrice = parseFloat(CalCulateRoofEndClosePrice) + parseFloat(post_data["building"].back_wall_price);
	}
	if (
		params.p_b_w !== "Half Dutch End" &&
		params.p_b_w !== "Half End" &&
		params.p_b_w !== "Close" &&
		params.p_b_w !== "Open" &&
		params.p_b_w !== "Half_Close" &&
		params.p_b_w !== "One_Fourth_Close" &&
		params.p_b_w !== "Three_Fourth_Close"
	) {
		if (params.p_b_w == "Gable") {
			if (params.p_v_w == true) {
				if (const_var.c_f_a_sCer[params.p_e_i] == 1) {
					vertiP2 =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_wall_price_changed != true
							? const_var.UpdatedPriceData.back_wall_price
							: vertiP2 + (data.gable_end[0].vertical_certified + data.gable_end[0].certified);
				} else {
					vertiP2 =
						UpdatePriceRecord == true && const_var.UpdatedPriceData.back_wall_price_changed != true
							? const_var.UpdatedPriceData.back_wall_price
							: vertiP2 + (data.gable_end[0].vertical + data.gable_end[0].uncertified);
				}
			} else {
				if (const_var.c_f_a_sCer[params.p_e_i] == 1) {
					vertiP2 = UpdatePriceRecord == true && const_var.UpdatedPriceData.back_wall_price_changed != true ? const_var.UpdatedPriceData.back_wall_price : vertiP2 + data.gable_end[0].certified;
				} else {
					vertiP2 = UpdatePriceRecord == true && const_var.UpdatedPriceData.back_wall_price_changed != true ? const_var.UpdatedPriceData.back_wall_price : vertiP2 + data.gable_end[0].uncertified;
				}
			}
		} else {
			if (params.p_v_w == true) {
				vertiP2 =
					UpdatePriceRecord == true && const_var.UpdatedPriceData.back_wall_price_changed != true
						? const_var.UpdatedPriceData.back_wall_price
						: vertiP2 + (data.gable_end[0].vertical_extended + data.gable_end[0].extended);
			} else {
				vertiP2 = UpdatePriceRecord == true && const_var.UpdatedPriceData.back_wall_price_changed != true ? const_var.UpdatedPriceData.back_wall_price : vertiP2 + data.gable_end[0].extended;
			}
		}
		post_data["building"].back_wall_price = utlis.convertToTwoDecimalNumber(vertiP2);
		t_c = parseFloat(t_c) + parseFloat(post_data["building"].back_wall_price);
		CalCulateRoofEndGablePrice = CalCulateRoofEndGablePrice + post_data["building"].back_wall_price;
	}

	return {
		t_c,
		CalCulateRoofEndClosePrice,
		post_data
	};
};
export const handleInsulationCalculation = ({
	const_var,
	params,
	utlis,
	post_data,
	UpdatePriceRecord,
	convertToTwoDecimalNumber,
	t_c,
	isLean,
	heritageNoInsulationCaseCenterBuilding,
	heritageNoInsulationCaseAllBuilding
}) => {
	if (const_var.cbInsulation != undefined && params.p_c_i && heritageNoInsulationCaseCenterBuilding != true && heritageNoInsulationCaseAllBuilding != true) {
		if (const_var.UpdatedPriceData.insulation_type && const_var.UpdatedPriceData.insulation_type && const_var.UpdatedPriceData.insulation_type.insulation_wall != undefined) {
			const_var.insulationPriceJson.insulation_wall = const_var.UpdatedPriceData.insulation_type.insulation_wall;
		}
		utlis.calcInsulationPrice();

		post_data["building"].insulation_price =
			UpdatePriceRecord &&
			const_var.UpdatedPriceData.insulation_price_changed != true &&
			(const_var.UpdatedPriceData.height_price_changed != true || const_var.UpdatedPriceData.roof_style_price_changed != true || const_var.UpdatedPriceData.bothLeanto != true)
				? const_var.UpdatedPriceData.insulation_price
				: convertToTwoDecimalNumber(const_var.CBInsulationPrice);

		let chkForInsulationPrice = commonFunctionForInsulationCalculations(post_data["building"].insulation_price, const_var.insulationPriceJson?.[params.p_i_o]?.insulation_id);

		if (chkForInsulationPrice != true) {
			t_c = parseFloat(t_c) + parseFloat(post_data["building"].insulation_price);
			post_data["building"]["insulation_commission"] = isLean ? const_var.post_data["building"]["insulation_commission"] || false : false;
		} else {
			if (post_data["building"]["insulation_commission"] != undefined) {
				post_data["building"]["insulation_commission"] = isLean ? const_var.post_data["building"]["insulation_commission"] || false : true;
			}
		}

		post_data["building"].insulation = params.p_c_i ? "custom" : params.p_f_i ? "full" : "roof_only";
		post_data["building"].insulation_type = const_var.insulationPriceJson[params.p_i_o];

		if (const_var.insulationPriceJson.length > 0) {
			if (post_data["building"].insulation_type == undefined) {
				post_data["building"].insulation_type = {};
			}
			post_data["building"].insulation_type.insulation_wall = const_var.insulationPriceJson.insulation_wall;
		}

		deleteUncheckWallsfromInsulationWalls(post_data["building"]);
	} else if (params.p_i_o != 0 && !const_var.isInsulaltionForOldQuotes && heritageNoInsulationCaseAllBuilding != true) {
		if (params.p_f_i) {
			let insulationPrice = 0,
				finalPrice = 0;

			if (
				const_var.insulationPriceJson != undefined &&
				const_var.insulationPriceJson.length > 0 &&
				const_var.insulationPriceJson[params.p_i_o] != undefined &&
				const_var.insulationPriceJson[params.p_i_o].end_cost != undefined &&
				const_var.insulationPriceJson[params.p_i_o].end_cost != 0 &&
				const_var.insulationPriceJson[params.p_i_o].side_cost != 0
			) {
				if (Object.keys(const_var.wallsData["center"]).length > 0) {
					insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].roof_insulation_cost);

					let isFreeStandingBuilding = false;

					if (params.p_b_t != undefined) {
						let selBuildingObj = Object.entries(const_var.defaultBuildingArr).find(([key, obj]) => obj.building_id == params.p_b_t);

						selBuildingObj = selBuildingObj && selBuildingObj.length > 0 ? selBuildingObj[1] : 0;

						isFreeStandingBuilding = selBuildingObj != 0 ? selBuildingObj?.image_name.includes("Free_Standing") : false;

						const_var.isFreeStandingBuilding = isFreeStandingBuilding;
					}

					if (params.p_f_w === "Close") {
						insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].end_cost || 0);
					}
					if (params.p_b_w === "Close") {
						insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].end_cost || 0);
					}
					if (!isFreeStandingBuilding && params.p_l_w === "Close") {
						insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].side_cost || 0);
					}
					if (params.p_r_w === "Close") {
						insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].side_cost || 0);
					}
					if (isFreeStandingBuilding && params.p_l_w === "Close") {
						insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].slope_side_cost || 0);
					}

					if (params.p_u_c) {
						insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].end_cost || 0);

						if (params.endStoragePositionZ != 0 && params.endStoragePositionZ != params.p_d - parseInt(params.p_u_t)) {
							insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].end_cost || 0);
						}

						if (!isFreeStandingBuilding && params.p_l_w != "Close") {
							insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].utility_side || 0);
						}
						if (!isFreeStandingBuilding && params.p_r_w != "Close") {
							insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].utility_side || 0);
						}

						if (isFreeStandingBuilding && params.p_r_w != "Close") {
							insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].utility_side || 0);
						}
						if (isFreeStandingBuilding && params.p_l_w != "Close") {
							insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].utility_slope_side_cost || 0);
						}
					}

					if (params.cB_addStorage_check_left) {
						if (params.p_f_w != "Close") {
							insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].utility_end || 0);
						}
						if (params.p_b_w != "Close") {
							insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].utility_end || 0);
						}
						insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].pitch_side || 0);
					}

					if (params.cB_addStorage_check_right) {
						if (params.p_f_w != "Close") {
							insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].utility_end || 0);
						}
						if (params.p_b_w != "Close") {
							insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].utility_end || 0);
						}
						insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o].pitch_side || 0);
					}

					if (heritageNoInsulationCaseCenterBuilding === true) {
						insulationPrice = 0;
					}
				}
			}

			let leanPrice = commonFunctionForRoofandFullBuildingInsulationPrice(post_data["building"], "fullBuilding", params.p_i_o, params);

			finalPrice += insulationPrice + leanPrice;

			post_data["building"].insulation = "full";
			post_data["building"].insulation_price =
				UpdatePriceRecord &&
				const_var.UpdatedPriceData.insulation_price_changed != true &&
				(const_var.UpdatedPriceData.height_price_changed != true || const_var.UpdatedPriceData.roof_style_price_changed != true || const_var.UpdatedPriceData.bothLeanto != true)
					? const_var.UpdatedPriceData.insulation_price
					: convertToTwoDecimalNumber(finalPrice);

			let chkForInsulationPrice = commonFunctionForInsulationCalculations(post_data["building"].insulation_price, const_var.insulationPriceJson[params.p_i_o]?.insulation_id);

			if (chkForInsulationPrice != true) {
				t_c = parseFloat(t_c) + parseFloat(post_data["building"].insulation_price);
				post_data["building"]["insulation_commission"] = false;
			} else {
				post_data["building"]["insulation_commission"] = true;
			}

			post_data["building"].insulation_type = const_var.insulationPriceJson[params.p_i_o];

			if (const_var.crmSetting.is_Edit && const_var.UpdatedPriceData && const_var.UpdatedPriceData.insulation_type && const_var.UpdatedPriceData.insulation_type.insulation_wall != undefined) {
				const_var.insulationPriceJson.insulation_wall = const_var.UpdatedPriceData.insulation_type.insulation_wall;
			}

			if (post_data["building"].insulation_type != undefined) {
				post_data["building"].insulation_type.insulation_wall = const_var.insulationPriceJson.insulation_wall;
			}
		}

		if (params.p_r_o) {
			let insulationPrice = 0,
				finalPrice = 0;

			if (const_var.insulationPriceJson != undefined && const_var.insulationPriceJson.length > 0 && heritageNoInsulationCaseCenterBuilding != true) {
				insulationPrice += parseFloat(const_var.insulationPriceJson[params.p_i_o]?.roof_insulation_cost);
			}

			let leanPrice = commonFunctionForRoofandFullBuildingInsulationPrice(post_data["building"], "roofOnly", params.p_i_o, params);

			finalPrice += insulationPrice + leanPrice;

			post_data["building"].insulation = "roof_only";
			post_data["building"].insulation_price =
				UpdatePriceRecord &&
				const_var.UpdatedPriceData.insulation_price_changed != true &&
				(const_var.UpdatedPriceData.height_price_changed != true || const_var.UpdatedPriceData.roof_style_price_changed != true || const_var.UpdatedPriceData.bothLeanto != true)
					? const_var.UpdatedPriceData.insulation_price
					: convertToTwoDecimalNumber(finalPrice);

			let chkForInsulationPrice = commonFunctionForInsulationCalculations(post_data["building"].insulation_price, const_var.insulationPriceJson[params.p_i_o]?.insulation_id);

			if (chkForInsulationPrice != true) {
				t_c = parseFloat(t_c) + parseFloat(post_data["building"].insulation_price);
				post_data["building"]["insulation_commission"] = false;
			} else {
				post_data["building"]["insulation_commission"] = true;
			}

			post_data["building"].insulation_type = const_var.insulationPriceJson[params.p_i_o];

			if (const_var.crmSetting.is_Edit && const_var.UpdatedPriceData && const_var.UpdatedPriceData.insulation_type && const_var.UpdatedPriceData.insulation_type.insulation_wall != undefined) {
				const_var.insulationPriceJson.insulation_wall = const_var.UpdatedPriceData.insulation_type.insulation_wall;
			}

			post_data["building"].insulation_type.insulation_wall = const_var.insulationPriceJson.insulation_wall;
		}
	} else {
		post_data["building"].insulation_price = 0;
	}

	return t_c;
};
export const getPricingDataforUtility = (val, combo, incloseVal) => {
	const_var.is_loader = true;

	let Mainval = 0;
	if (params.p_b_t == "2") {
		Mainval = params.p_r_s == 4 || params.p_r_s == 5 ? params.p_h - 5 : params.p_h - 3;
	} else {
		Mainval = 0;
	}
	const_var.CallApionAction = true;
	const_var.isPriceAPIcalled = true;
	const_var.isUtilityChanges = true;
	const_var.onDragUtilityPriceUpdateLeft = false;
	const_var.onDragUtilityPriceUpdateRight = false;
	const_var.onDragUtilityPriceUpdateFront = false;
	const_var.onDragUtilityPriceUpdateBack = false;
	const_var.onDragUtilityPriceUpdateCenterBuilding = false;
	const_var.isWainscotManualPriceUpdate = false;

	if (const_var.DistanceArr[params.p_b_t][params.p_r_s] != undefined) {
		params.p_u_t =
			params.p_u_t > const_var.DistanceArr[params.p_b_t][params.p_r_s] * 1
				? params.p_u_t
				: Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]) * const_var.DistanceArr[params.p_b_t][params.p_r_s];
	}
	let apiData = "";
	let exactCalculation = 0;
	if (parseInt(incloseVal) > params.p_w / 2) {
		exactCalculation = parseInt(params.p_h) + parseInt(params.p_r_p);
	} else {
		exactCalculation = parseInt(params.p_h + Math.ceil((params.p_r_p / (params.p_w / 2)) * incloseVal));
	}
	if (exactCalculation > const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value) {
		exactCalculation = const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value;
	}

	if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
		let chkFixedWidth = false;
		chkFixedWidth = const_var.c_m_a[params.p_b_t] ? (const_var.c_m_a[params.p_b_t].fixed_new_leg_width ? (const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0 ? true : false) : false) : false;
		if (combo != undefined) {
			if (parseInt(incloseVal) > params.p_w / 2) {
				exactCalculation = parseInt(Math.round(params.p_h - params.p_r_p) + Math.ceil((params.p_r_p / params.p_w) * incloseVal)); //parseInt(Math.round(params.p_h-params.p_r_p) + Math.ceil((params.p_r_p * (params.p_w/2))/12)) //parseInt(Math.round(params.p_h-params.p_r_p)+(Math.ceil(((params.p_r_p/(params.p_w/2))))))
			} else {
				exactCalculation = parseInt(Math.round(params.p_h - params.p_r_p) + Math.ceil((params.p_r_p / params.p_w) * incloseVal));
			}
			if (exactCalculation > const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value) {
				exactCalculation = const_var.buildingHeightArray[const_var.buildingHeightArray.length - 1].value;
			}
			apiData = {
				width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
				height: params.p_h,
				single_slope_height:
					const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
						? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
						: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12),
				length: params.p_d,
				map_id: const_var.Map_Id[params.p_b_t],
				roof_id: params.p_r_s,
				lean_to_height: 0,
				utility_width: parseInt(incloseVal),
				pitch_height: exactCalculation,
				is_smaller_frame_width: chkFixedWidth
			};
		} else {
			apiData = {
				width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
				height: params.p_h,
				single_slope_height:
					const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
						? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
						: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12),
				length: params.p_d,
				map_id: const_var.Map_Id[params.p_b_t],
				roof_id: params.p_r_s,
				lean_to_height: 0,
				utility_length: params.p_u_c == true ? params.p_u_t : 0,
				is_smaller_frame_width: chkFixedWidth
			};
		}
	} else {
		if (combo != undefined) {
			apiData = {
				width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
				height: params.p_h,
				length: params.p_d,
				map_id: const_var.Map_Id[params.p_b_t],
				roof_id: params.p_r_s,
				lean_to_height: Mainval,
				utility_width: parseInt(incloseVal),
				pitch_height: exactCalculation
			};
		} else {
			apiData = {
				width: params.p_b_t == "2" ? params.p_w + 24 : params.p_w,
				height: params.p_h,
				length: params.p_d,
				map_id: const_var.Map_Id[params.p_b_t],
				roof_id: params.p_r_s,
				lean_to_height: Mainval,
				utility_length: params.p_u_t
			};
		}
	}
	if (params.p_u_c == true || incloseVal != undefined) {
		const_var.UpdatedPriceData.connection_fee_end_changed = true;
		const_var.UpdatedPriceData.connection_fee_side_changed = true;
		const_var.UpdatedPriceData.utility_price_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.insulation_price = undefined;
		const_var.UpdatedPriceData.insulation_price_changed = true;
		if (params.p_j_t == true) {
			const_var.UpdatedPriceData.common_length_changed = true;
			const_var.UpdatedPriceData.common_left_lean_length_changed = true;
			const_var.UpdatedPriceData.common_right_lean_length_changed = true;
			const_var.UpdatedPriceData.common_front_lean_length_changed = true;
			const_var.UpdatedPriceData.common_back_lean_length_changed = true;
		}
		if (params.p_i_o != 0) {
			const_var.UpdatedPriceData.height_price_changed = true;
			const_var.UpdatedPriceData.roof_style_price_changed = true;
			const_var.UpdatedPriceData.bothLeanto = true;
		}
		if (apiData != undefined) {
			apiData.gauge = const_var.g_v;
		}
		if (const_var.b_o_J_1[params.p_b_t] == "Custom Buildings") {
			apiData.is_lean_to_price = true;
		}
		if (params.p_r_p != undefined) {
			apiData.pitch_type = `${params.p_r_p}_12`;
		}
		if (const_var.selSidingObj != {} && const_var.selSidingObj.name != "metal" && const_var.selSidingObj.price_type != "%") {
			if (const_var.selSidingObj.name == const_var.selSidingOption) {
				apiData.side_end_name = const_var.selSidingObj.name;
			}
		}
		if (params.m_s_n == 122 && const_var.selSidingObj != {} && const_var.selSidingObj.name.includes("board_and_batten")) {
			apiData.send_default_data = true;
		}
		let checkDollarExist = const_var.c_m_a?.[const_var.post_data.building.building_type]?.wainscot_details?.find((wain) => wain?.name && params.wainscotTexture?.includes(wain?.name));
		if (params.p_w_c_n && checkDollarExist?.price_type == "$" && params.wainscotTexture != "metal") {
			apiData.applicable_wainscot = applicableWainscot();
		}

		return async (dispatch) => {
			const {response} = await getBuildingPricingData();
			if (response?.data?.success == true && response?.data?.data != undefined && response?.data?.data?.extra_add_on && response?.data?.data?.extra_add_on.length > 0) {
				let addOnItems = const_var.extraAddOnItemsArray?.map((item) => {
					if (item) {
						return item.label;
					}
				});

				if (addOnItems) {
					addOnItems?.map((item) => {
						if (item && const_var.UpdatedPriceData?.elements?.[item]) {
							const_var.UpdatedPriceData.elements[item].item_price = 0;
							const_var.UpdatedPriceData.elements[item].is_edit = false;
						}
					});
				}
			}

			if (const_var.stateData?.fetch_price_for?.surcharge && const_var.surcharge_amount_is_edit != true) {
				const_var.UpdatedPriceData.surcharge_amount = undefined;
			}
			if (params.m_s_n == 122 && const_var.selSidingObj != {} && const_var.selSidingObj.name.includes("board_and_batten") && response?.data?.data) {
				setZeroPriceOverhang(response.data.data);
			}
			const_var.engineer_drawings_price_changed = true;
			const_var.is_edit_labour = undefined;
			if (params.m_s_n == 11 || params.m_s_n == 54 || params.m_s_n == 147 || params.m_s_n == 160) {
				const_var.isCheckGroundCertificate = true;
			}
			if (response.data?.data?.additional_features?.length > 0) {
				response.data.data.additional_features.map((value, key) => {
					value.additional_feature = value.additional_feature.trim();
					if (value != null && value.additional_feature.toLowerCase().includes("colored screws")) {
						const_var.UpdatedPriceData.coloredElements = true;
					}
				});
			}
			const_var.UpdatedPriceData.insulation_price = undefined;
			if (
				params.p_i_o != 0 &&
				response.data.data != undefined &&
				response.data.data.insulation != undefined &&
				const_var.isInsulaltionForOldQuotes == false &&
				const_var.crmSetting.is_Edit == true &&
				response.data.data.insulation.filter((obj) => obj.insulation_id == params.p_i_o).length == 0
			) {
				params.p_i_o = response.data.data.insulation[0].insulation_id; //0
				params.selectedInsulationId = response.data.data.insulation[0].insulation_id;

				params.insulation.center.isCheked = false;
				params.insulation.center.insulationId = 0;
				params.insulation.center.roofOnly = false;
				params.insulation.center.fullBuilding = false;
				params.insulation.center.custom = false;
				params.insulation.center.showInsulationOptions = false;
				params.insulation.center.isDisableFullInsulation = false;
			}
			const_var.installationsurfaceChange = true;
			const_var.UpdatedPriceData.insulation_price_changed = true;
			const_var.holdPricingResponse = response.data?.data;
			if (params.p_u_c == true) {
				const_var.UpdatedPriceData.utility_price_changed = true;
			}
			utils.prepareLoftDropdown();
			// utils.handleSelectionIndexingForExtraAddOn(response.data?.data);
			// utils.handleSelectionIndexingForAdditionFeature(response.data?.data);
			// utils.checkForExtraAddOnCheckedoption();
			dispatch(setPricingData(response.data, true));
			dispatch(CheckDoorWindowsInstallationFees(response.data));
			const_var.isUpdate4ftLegLogic = /* true */ params.m_s_n == 3 ? true : false;

			const_var.engineer_drawings_price_changed = true;
			const_var.is_edit_labour = undefined;
			if (params.m_s_n == 11 || params.m_s_n == 54 || params.m_s_n == 147 || params.m_s_n == 160) {
				const_var.isCheckGroundCertificate = true;
			}
			if (response.data?.data?.additional_features?.length > 0) {
				response.data.data.additional_features.map((value, key) => {
					value.additional_feature = value.additional_feature.trim();
					if (value != null && value.additional_feature.toLowerCase().includes("colored screws")) {
						const_var.UpdatedPriceData.coloredElements = true;
					}
				});
			}
			const_var.UpdatedPriceData.insulation_price = undefined;
			const_var.UpdatedPriceData.insulation_price_changed = true;
			if (
				params.p_i_o != 0 &&
				response.data.data != undefined &&
				response.data.data.insulation != undefined &&
				const_var.isInsulaltionForOldQuotes == false &&
				const_var.crmSetting.is_Edit == true &&
				response.data.data.insulation.filter((obj) => obj.insulation_id == params.p_i_o).length == 0
			) {
				params.p_i_o = response.data.data.insulation[0].insulation_id; //0
				params.selectedInsulationId = response.data.data.insulation[0].insulation_id;

				params.insulation.center.isCheked = false;
				params.insulation.center.insulationId = 0;
				params.insulation.center.roofOnly = false;
				params.insulation.center.fullBuilding = false;
				params.insulation.center.custom = false;
				params.insulation.center.showInsulationOptions = false;
				params.insulation.center.isDisableFullInsulation = false;
			}
			const_var.installationsurfaceChange = true;
			const_var.UpdatedPriceData.insulation_price_changed = true;
			dispatch(setPricingData(response.data, true));
			dispatch(CheckDoorWindowsInstallationFees(response.data));
		};
	} else {
		return (dispatch) => {
			dispatch({ type: "UTILITYPRICECALCULATION", value: const_var.a_p_d_a, str: params.p_u_c });
		};
	}
};
